import { defineComponent as _defineComponent } from 'vue'
import { MonetizationType, ObjectType, PresentationType } from '@/@types/graphql-types';
import { useI18n } from '@/helpers/composables/useI18n';
import { enquote } from '@/helpers/composables/useSpinningText';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { computed } from 'vue';
import { getDvdBluraySpinningTextPlaceHolder } from './data/dvd-bluray';


export default /*#__PURE__*/_defineComponent({
  __name: 'DvdBluray',
  props: {
    title: null,
    titleObjectType: null,
    dvdBluRayOffers: null,
    streamingOffers: null,
    seasonNumber: null
  },
  setup(__props: any) {

const props = __props as {
	title: string;
	titleObjectType: ObjectType;
	dvdBluRayOffers: TitleDetail['offers'];
	streamingOffers: TitleDetail['offers'];
	seasonNumber?: number | null;
};



const getOfferByMonetizationTypeAndPresentaionType = (offers: TitleDetail['offers']) => {
	return offers.reduce((acc, offer) => {
		const key = (
			offer.presentationType === PresentationType.Bluray_4K ? PresentationType.Bluray : offer.presentationType
		) as PresentationType.Dvd | PresentationType.Bluray;

		if (!acc[key]) {
			acc[key] = {};
		}

		if (!acc[key][offer.monetizationType]) {
			acc[key][offer.monetizationType] = [];
		}

		if (!acc[key][offer.monetizationType].includes(offer.package.clearName)) {
			acc[key][offer.monetizationType].push(offer.package.clearName);
		}

		return acc;
	}, {} as Record<PresentationType.Dvd | PresentationType.Bluray, Record<string, string[]>>);
};

function getFinaleText(
	title: string,
	language: string,
	hasStreamingOffers: boolean,
	dvdOffers: TitleDetail['offers'],
	blurayOffers: TitleDetail['offers']
) {
	const dvdOfferMap = getOfferByMonetizationTypeAndPresentaionType([dvdOffers, blurayOffers].flat());
	const sortedPresenationType = [PresentationType.Dvd, PresentationType.Bluray];
	const sortedMonetizationType = [MonetizationType.Buy, MonetizationType.Rent];

	const key = Object.keys(dvdOfferMap)
		.sort(
			(a, b) =>
				sortedPresenationType.indexOf(a as PresentationType) -
				sortedPresenationType.indexOf(b as PresentationType)
		)
		.map(presentationType => {
			const monetizationTypes = Object.keys(dvdOfferMap[presentationType] ?? {}).sort(
				(a, b) =>
					sortedMonetizationType.indexOf(a as MonetizationType) -
					sortedMonetizationType.indexOf(b as MonetizationType)
			);
			return `${presentationType}-${monetizationTypes.join('-')}`;
		})
		.join('-');

	const offersObj = {
		dvdOffers: Object.values(dvdOfferMap[PresentationType.Dvd] ?? {})
			.flat()
			.join(', '),
		blurayOffers: Object.values(dvdOfferMap[PresentationType.Bluray] ?? {})
			.flat()
			.join(', '),
		offers: Array.from(
			new Set(
				Object.values(dvdOfferMap)
					.flatMap(obj => Object.values(obj))
					.flat()
			)
		).join(', '),
	};

	const textPlaceHolderByLanguage = getDvdBluraySpinningTextPlaceHolder(props.titleObjectType);

	return (
		(
			textPlaceHolderByLanguage?.[language]?.[hasStreamingOffers ? 'with-streaming' : 'no-streaming']?.[
				key
			] as string
		)
			?.replaceAll('{{title}}', title)
			?.replaceAll('{{dvd-offers}}', offersObj.dvdOffers)
			?.replaceAll('{{blu-ray-offers}}', offersObj.blurayOffers)
			?.replaceAll('{{offers}}', offersObj.offers) || ''
	);
}

const { language, locale } = useLanguageStore();
const { tc } = useI18n();
const text = computed(() => {
	const displayedTitle =
		props.seasonNumber == null ? props.title : `${props.title} - ${tc('WEBAPP_SEASON')} ${props.seasonNumber}`;
	return getFinaleText(
		enquote(displayedTitle, locale.value),
		language.value,
		props.streamingOffers.length > 0,
		props.dvdBluRayOffers.filter(offer => offer.presentationType === 'DVD'),
		props.dvdBluRayOffers.filter(
			offer => offer.presentationType === 'BLURAY' || offer.presentationType === 'BLURAY_4K'
		)
	);
});

return { __sfc: true,props, getOfferByMonetizationTypeAndPresentaionType, getFinaleText, language, locale, tc, text }
}

})